<template>
  <div class="row">
    <div class="col-md-6">
      <div
        class="alert alert-warning"
      >1.1.1. Соответствие информации о деятельности организации социальной сферы, размещенной на общедоступных информационных ресурсах, ее содержанию и порядку (форме), установленным нормативными правовыми актами на информационных стендах в помещении организации социальной сферы</div>
      <div class="alert alert-info">I. Общая информация об организации культуры</div>
      <div class="well">
        <strong>1. Полное и сокращенное наименование организации культуры, почтовый адрес, контактные телефоны и адреса электронной почты</strong>
        <div class="form-group clearfix">
          <input name="pole_0" id="pole_0_0" type="radio" value="0" v-model="answers[0]"/>
          <label class="form-control btn btn-info" for="pole_0_0">Да</label>
          <input name="pole_0" id="pole_0_1" type="radio" value="1" v-model="answers[0]"/>
          <label class="form-control btn btn-info" for="pole_0_1">Нет</label>
          <input name="pole_0" id="pole_0_2" type="radio" value="2" v-model="answers[0]"/>
          <label class="form-control btn btn-info" for="pole_0_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>2. Место нахождения организации культуры и ее филиалов (при наличии)</strong>
        <div class="form-group clearfix">
          <input name="pole_1" id="pole_1_0" type="radio" value="0" v-model="answers[1]"/>
          <label class="form-control btn btn-info" for="pole_1_0">Да</label>
          <input name="pole_1" id="pole_1_1" type="radio" value="1" v-model="answers[1]"/>
          <label class="form-control btn btn-info" for="pole_1_1">Нет</label>
          <input name="pole_1" id="pole_1_2" type="radio" value="2" v-model="answers[1]"/>
          <label class="form-control btn btn-info" for="pole_1_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>3. Дата создания организации культуры, сведения об учредителе/учредителях, контактные телефоны, адрес сайта, адреса электронной почты учредителя/учредителей</strong>
        <div class="form-group clearfix">
          <input name="pole_2" id="pole_2_0" type="radio" value="0" v-model="answers[2]"/>
          <label class="form-control btn btn-info" for="pole_2_0">Да</label>
          <input name="pole_2" id="pole_2_1" type="radio" value="1" v-model="answers[2]"/>
          <label class="form-control btn btn-info" for="pole_2_1">Нет</label>
          <input name="pole_2" id="pole_2_2" type="radio" value="2" v-model="answers[2]"/>
          <label class="form-control btn btn-info" for="pole_2_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>4. Структура и органы управления организации культуры; фамилии, имена, отчества и должности руководителей организации культуры, ее структурных подразделений и филиалов (при их наличии), контактные телефоны, адреса сайтов структурных подразделений (при наличии), адреса электронной почты</strong>
        <div class="form-group clearfix">
          <input name="pole_3" id="pole_3_0" type="radio" value="0" v-model="answers[3]"/>
          <label class="form-control btn btn-info" for="pole_3_0">Да</label>
          <input name="pole_3" id="pole_3_1" type="radio" value="1" v-model="answers[3]"/>
          <label class="form-control btn btn-info" for="pole_3_1">Нет</label>
          <input name="pole_3" id="pole_3_2" type="radio" value="2" v-model="answers[3]"/>
          <label class="form-control btn btn-info" for="pole_3_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>5. Режим, график работы организации культуры</strong>
        <div class="form-group clearfix">
          <input name="pole_4" id="pole_4_0" type="radio" value="0" v-model="answers[4]"/>
          <label class="form-control btn btn-info" for="pole_4_0">Да</label>
          <input name="pole_4" id="pole_4_1" type="radio" value="1" v-model="answers[4]"/>
          <label class="form-control btn btn-info" for="pole_4_1">Нет</label>
          <input name="pole_4" id="pole_4_2" type="radio" value="2" v-model="answers[4]"/>
          <label class="form-control btn btn-info" for="pole_4_2">Частично</label>
        </div>
      </div>
      <div class="alert alert-info">II. Информация о деятельности организации культуры</div>
      <div class="well">
        <strong>6. Виды предоставляемых услуг организацией культуры</strong>
        <div class="form-group clearfix">
          <input name="pole_5" id="pole_5_0" type="radio" value="0" v-model="answers[5]"/>
          <label class="form-control btn btn-info" for="pole_5_0">Да</label>
          <input name="pole_5" id="pole_5_1" type="radio" value="1" v-model="answers[5]"/>
          <label class="form-control btn btn-info" for="pole_5_1">Нет</label>
          <input name="pole_5" id="pole_5_2" type="radio" value="2" v-model="answers[5]"/>
          <label class="form-control btn btn-info" for="pole_5_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>7. Перечень оказываемых платных услуг (при наличии)*; цены (тарифы) на услуги (при наличии платных услуг), копии документов о порядке предоставления услуг за плату, нормативных правовых актов, устанавливающих цены (тарифы) на услуги (при наличии платных услуг)*</strong>
        <div class="form-group clearfix">
          <input name="pole_6" id="pole_6_0" type="radio" value="0" v-model="answers[6]"/>
          <label class="form-control btn btn-info" for="pole_6_0">Да</label>
          <input name="pole_6" id="pole_6_1" type="radio" value="1" v-model="answers[6]"/>
          <label class="form-control btn btn-info" for="pole_6_1">Нет</label>
          <input name="pole_6" id="pole_6_2" type="radio" value="2" v-model="answers[6]"/>
          <label class="form-control btn btn-info" for="pole_6_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>8. Информация о планируемых мероприятиях (анонсы, афиши, акции), новости, события</strong>
        <div class="form-group clearfix">
          <input name="pole_7" id="pole_7_0" type="radio" value="0" v-model="answers[7]"/>
          <label class="form-control btn btn-info" for="pole_7_0">Да</label>
          <input name="pole_7" id="pole_7_1" type="radio" value="1" v-model="answers[7]"/>
          <label class="form-control btn btn-info" for="pole_7_1">Нет</label>
          <input name="pole_7" id="pole_7_2" type="radio" value="2" v-model="answers[7]"/>
          <label class="form-control btn btn-info" for="pole_7_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>9. Копии лицензий на осуществление деятельность, подлежащей лицензированию в соответствии с законодательством Российской Федерации (при осуществлении соответствующих видов деятельности)*</strong>
        <div class="form-group clearfix">
          <input name="pole_8" id="pole_8_0" type="radio" value="0" v-model="answers[8]"/>
          <label class="form-control btn btn-info" for="pole_8_0">Да</label>
          <input name="pole_8" id="pole_8_1" type="radio" value="1" v-model="answers[8]"/>
          <label class="form-control btn btn-info" for="pole_8_1">Нет</label>
          <input name="pole_8" id="pole_8_2" type="radio" value="2" v-model="answers[8]"/>
          <label class="form-control btn btn-info" for="pole_8_2">Частично</label>
        </div>
      </div>
      <div class="alert alert-info">III. Информация о независимой оценке качества</div>
      <div class="well">
        <strong>10. Результаты независимой оценки качества условий оказания услуг, планы по улучшению качества работы организации культуры (по устранению недостатков, выявленных по итогам независимой оценки качества)</strong>
        <div class="form-group clearfix">
          <input name="pole_9" id="pole_9_0" type="radio" value="0" v-model="answers[9]"/>
          <label class="form-control btn btn-info" for="pole_9_0">Да</label>
          <input name="pole_9" id="pole_9_1" type="radio" value="1" v-model="answers[9]"/>
          <label class="form-control btn btn-info" for="pole_9_1">Нет</label>
          <input name="pole_9" id="pole_9_2" type="radio" value="2" v-model="answers[9]"/>
          <label class="form-control btn btn-info" for="pole_9_2">Частично</label>
        </div>
      </div>
      <div
        class="alert alert-warning"
      >1.1.2. Соответствие информации о деятельности организации социальной сферы, размещенной на общедоступных информационных ресурсах, ее содержанию и порядку (форме), установленным нормативными правовыми актами на официальном сайте организации социальной сферы в сети Интернет</div>
      <div class="alert alert-info">I. Общая информация об организации культуры</div>
      <div class="well">
        <strong>1. Полное и сокращенное наименование организации культуры, почтовый адрес, контактные телефоны и адреса электронной почты</strong>
        <div class="form-group clearfix">
          <input name="pole_10" id="pole_10_0" type="radio" value="0" v-model="answers[10]"/>
          <label class="form-control btn btn-info" for="pole_10_0">Да</label>
          <input name="pole_10" id="pole_10_1" type="radio" value="1" v-model="answers[10]"/>
          <label class="form-control btn btn-info" for="pole_10_1">Нет</label>
          <input name="pole_10" id="pole_10_2" type="radio" value="2" v-model="answers[10]"/>
          <label class="form-control btn btn-info" for="pole_10_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>2.Место нахождения организации культуры и ее филиалов (при наличии)</strong>
        <div class="form-group clearfix">
          <input name="pole_11" id="pole_11_0" type="radio" value="0" v-model="answers[11]"/>
          <label class="form-control btn btn-info" for="pole_11_0">Да</label>
          <input name="pole_11" id="pole_11_1" type="radio" value="1" v-model="answers[11]"/>
          <label class="form-control btn btn-info" for="pole_11_1">Нет</label>
           <input name="pole_11" id="pole_11_2" type="radio" value="2" v-model="answers[11]"/>
          <label class="form-control btn btn-info" for="pole_11_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>3. Дата создания организации культуры, сведения об учредителе/учредителях, контактные телефоны, адрес сайта, адреса электронной почты учредителя/учредителей</strong>
        <div class="form-group clearfix">
          <input name="pole_12" id="pole_12_0" type="radio" value="0" v-model="answers[12]"/>
          <label class="form-control btn btn-info" for="pole_12_0">Да</label>
          <input name="pole_12" id="pole_12_1" type="radio" value="1" v-model="answers[12]"/>
          <label class="form-control btn btn-info" for="pole_12_1">Нет</label>
           <input name="pole_12" id="pole_12_2" type="radio" value="2" v-model="answers[12]"/>
          <label class="form-control btn btn-info" for="pole_12_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>4. Учредительные документы (копия устава организации культуры, свидетельство о государственной регистрации, решения учредителя о создании организации культуры и назначении ее руководителя, положения о филиалах и представительствах (при наличии))</strong>
        <div class="form-group clearfix">
          <input name="pole_13" id="pole_13_0" type="radio" value="0" v-model="answers[13]"/>
          <label class="form-control btn btn-info" for="pole_13_0">Да</label>
          <input name="pole_13" id="pole_13_1" type="radio" value="1" v-model="answers[13]"/>
          <label class="form-control btn btn-info" for="pole_13_1">Нет</label>
           <input name="pole_13" id="pole_13_2" type="radio" value="2" v-model="answers[13]"/>
          <label class="form-control btn btn-info" for="pole_13_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>5. Структура и органы управления организации культуры; фамилии, имена, отчества и должности руководителей организации культуры, ее структурных подразделений и филиалов (при их наличии), контактные телефоны, адреса сайтов структурных подразделений (при наличии), адреса электронной почты</strong>
        <div class="form-group clearfix">
          <input name="pole_14" id="pole_14_0" type="radio" value="0" v-model="answers[14]"/>
          <label class="form-control btn btn-info" for="pole_14_0">Да</label>
          <input name="pole_14" id="pole_14_1" type="radio" value="1" v-model="answers[14]"/>
          <label class="form-control btn btn-info" for="pole_14_1">Нет</label>
          <input name="pole_14" id="pole_14_2" type="radio" value="2" v-model="answers[14]"/>
          <label class="form-control btn btn-info" for="pole_14_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>6. Режим, график работы организации культуры</strong>
        <div class="form-group clearfix">
          <input name="pole_15" id="pole_15_0" type="radio" value="0" v-model="answers[15]"/>
          <label class="form-control btn btn-info" for="pole_15_0">Да</label>
          <input name="pole_15" id="pole_15_1" type="radio" value="1" v-model="answers[15]"/>
          <label class="form-control btn btn-info" for="pole_15_1">Нет</label>
          <input name="pole_15" id="pole_15_2" type="radio" value="2" v-model="answers[15]"/>
          <label class="form-control btn btn-info" for="pole_15_2">Частично</label>
        </div>
      </div>
      <div class="alert alert-info">II. Информация о деятельности организации культуры</div>
      <div class="well">
        <strong>7. Виды предоставляемых услуг организацией культуры</strong>
        <div class="form-group clearfix">
          <input name="pole_16" id="pole_16_0" type="radio" value="0" v-model="answers[16]"/>
          <label class="form-control btn btn-info" for="pole_16_0">Да</label>
          <input name="pole_16" id="pole_16_1" type="radio" value="1" v-model="answers[16]"/>
          <label class="form-control btn btn-info" for="pole_16_1">Нет</label>
          <input name="pole_16" id="pole_16_2" type="radio" value="2" v-model="answers[16]"/>
          <label class="form-control btn btn-info" for="pole_16_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>8. Перечень оказываемых платных услуг (при наличии)*; цены (тарифы) на услуги (при наличии платных услуг), копии документов о порядке предоставления услуг за плату, нормативных правовых актов, устанавливающих цены (тарифы) на услуги (при наличии платных услуг)*</strong>
        <div class="form-group clearfix">
          <input name="pole_17" id="pole_17_0" type="radio" value="0" v-model="answers[17]"/>
          <label class="form-control btn btn-info" for="pole_17_0">Да</label>
          <input name="pole_17" id="pole_17_1" type="radio" value="1" v-model="answers[17]"/>
          <label class="form-control btn btn-info" for="pole_17_1">Нет</label>
          <input name="pole_17" id="pole_17_2" type="radio" value="2" v-model="answers[17]"/>
          <label class="form-control btn btn-info" for="pole_17_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>9. Материально-техническое обеспечение предоставления услуг</strong>
        <div class="form-group clearfix">
          <input name="pole_18" id="pole_18_0" type="radio" value="0" v-model="answers[18]"/>
          <label class="form-control btn btn-info" for="pole_18_0">Да</label>
          <input name="pole_18" id="pole_18_1" type="radio" value="1" v-model="answers[18]"/>
          <label class="form-control btn btn-info" for="pole_18_1">Нет</label>
          <input name="pole_18" id="pole_18_2" type="radio" value="2" v-model="answers[18]"/>
          <label class="form-control btn btn-info" for="pole_18_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>10. Копия плана финансово-хозяйственной деятельности организации культуры, утвержденного в установленном законодательством Российской Федерации порядке, или бюджетной сметы (информация об объеме предоставляемых услуг)</strong>
        <div class="form-group clearfix">
          <input name="pole_19" id="pole_19_0" type="radio" value="0" v-model="answers[19]"/>
          <label class="form-control btn btn-info" for="pole_19_0">Да</label>
          <input name="pole_19" id="pole_19_1" type="radio" value="1" v-model="answers[19]"/>
          <label class="form-control btn btn-info" for="pole_19_1">Нет</label>
          <input name="pole_19" id="pole_19_2" type="radio" value="2" v-model="answers[19]"/>
          <label class="form-control btn btn-info" for="pole_19_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>11. Информация о планируемых мероприятиях (анонсы, афиши, акции), новости, события</strong>
        <div class="form-group clearfix">
          <input name="pole_20" id="pole_20_0" type="radio" value="0" v-model="answers[20]"/>
          <label class="form-control btn btn-info" for="pole_20_0">Да</label>
          <input name="pole_20" id="pole_20_1" type="radio" value="1" v-model="answers[20]"/>
          <label class="form-control btn btn-info" for="pole_20_1">Нет</label>
          <input name="pole_20" id="pole_20_2" type="radio" value="2" v-model="answers[20]"/>
          <label class="form-control btn btn-info" for="pole_20_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>12.Копии лицензий на осуществление деятельность, подлежащей лицензированию в соответствии с законодательством Российской Федерации (при осуществлении соответствующих видов деятельности)*</strong>
        <div class="form-group clearfix">
          <input name="pole_21" id="pole_21_0" type="radio" value="0" v-model="answers[21]"/>
          <label class="form-control btn btn-info" for="pole_21_0">Да</label>
          <input name="pole_21" id="pole_21_1" type="radio" value="1" v-model="answers[21]"/>
          <label class="form-control btn btn-info" for="pole_21_1">Нет</label>
          <input name="pole_21" id="pole_21_2" type="radio" value="2" v-model="answers[21]"/>
          <label class="form-control btn btn-info" for="pole_21_2">Частично</label>
        </div>
      </div>

      <div class="alert alert-info">III. Информация о независимой оценке качества</div>

      <div class="well">
        <strong>13.Результаты независимой оценки качества условий оказания услуг, планы по улучшению качества работы организации культуры (по устранению недостатков, выявленных по итогам независимой оценки качества)</strong>
        <div class="form-group clearfix">
          <input name="pole_22" id="pole_22_0" type="radio" value="0" v-model="answers[22]"/>
          <label class="form-control btn btn-info" for="pole_22_0">Да</label>
          <input name="pole_22" id="pole_22_1" type="radio" value="1" v-model="answers[22]"/>
          <label class="form-control btn btn-info" for="pole_22_1">Нет</label>
          <input name="pole_22" id="pole_22_2" type="radio" value="2" v-model="answers[22]"/>
          <label class="form-control btn btn-info" for="pole_22_2">Частично</label>
        </div>
      </div>

      <div
        class="alert alert-warning"
      >Показатель 1.2. «Наличие на официальном сайте организации информация о дистанционных способах обратной связи и взаимодействия с получателями услуг и их функционирование»</div>
      <div
        class="alert alert-info"
      >1.2.1. Наличие на официальном сайте организации информации о дистанционных способах взаимодействия с получателями услуг и их функционирование:</div>

      <div class="well">
        <strong>1. абонентского номера телефона</strong>
        <div class="form-group clearfix">
          <input name="pole_23" id="pole_23_0" type="radio" value="0" v-model="answers[23]"/>
          <label class="form-control btn btn-info" for="pole_23_0">Да</label>
          <input name="pole_23" id="pole_23_1" type="radio" value="1" v-model="answers[23]"/>
          <label class="form-control btn btn-info" for="pole_23_1">Нет</label>
           <input name="pole_23" id="pole_23_2" type="radio" value="2" v-model="answers[23]"/>
          <label class="form-control btn btn-info" for="pole_23_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>2. Копия плана финансово-хо2) адрес электронной почты;</strong>
        <div class="form-group clearfix">
          <input name="pole_24" type="radio" id="pole_24_0" value="0" v-model="answers[24]"/>
          <label class="form-control btn btn-info" for="pole_24_0">Да</label>
          <input name="pole_24" type="radio" id="pole_24_1" value="1" v-model="answers[24]"/>
          <label class="form-control btn btn-info" for="pole_24_1">Нет</label>
          <input name="pole_24" type="radio" id="pole_24_2" value="2" v-model="answers[24]"/>
          <label class="form-control btn btn-info" for="pole_24_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>3) электронных сервисов (для подачи электронного обращения (жалобы, предложения), получения консультации по оказываемым услугам и иных);</strong>
        <div class="form-group clearfix">
          <input name="pole_25" id="pole_25_0" type="radio" value="0" v-model="answers[25]"/>
          <label class="form-control btn btn-info" for="pole_25_0">Да</label>
          <input name="pole_25" id="pole_25_1" type="radio" value="1" v-model="answers[25]"/>
          <label class="form-control btn btn-info" for="pole_25_1">Нет</label>
          <input name="pole_25" id="pole_25_2" type="radio" value="2" v-model="answers[25]"/>
          <label class="form-control btn btn-info" for="pole_25_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>4) раздела официального сайта «Часто задаваемые вопросы»;</strong>
        <div class="form-group clearfix">
          <input name="pole_26" id="pole_26_0" type="radio" value="0" v-model="answers[26]"/>
          <label class="form-control btn btn-info" for="pole_26_0">Да</label>
          <input name="pole_26" id="pole_26_1" type="radio" value="1" v-model="answers[26]"/>
          <label class="form-control btn btn-info" for="pole_26_1">Нет</label>
          <input name="pole_26" id="pole_26_2" type="radio" value="2" v-model="answers[26]"/>
          <label class="form-control btn btn-info" for="pole_26_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>5) технической возможности выражения получателем услуг мнения о качестве условий оказания услуг организацией социальной сферы (наличие анкеты для опроса граждан или гиперссылки на нее);</strong>
        <div class="form-group clearfix">
          <input name="pole_27" id="pole_27_0" type="radio" value="0" v-model="answers[27]"/>
          <label class="form-control btn btn-info" for="pole_27_0">Да</label>
          <input name="pole_27" id="pole_27_1" type="radio" value="1" v-model="answers[27]"/>
          <label class="form-control btn btn-info" for="pole_27_1">Нет</label>
          <input name="pole_27" id="pole_27_2" type="radio" value="2" v-model="answers[27]"/>
          <label class="form-control btn btn-info" for="pole_27_2">Частично</label>
        </div>
      </div>

      <div class="well">
        <strong>6) иного дистанционного способа взаимодействия.</strong>
        <div class="form-group clearfix">
          <input name="pole_28" id="pole_28_0" type="radio" value="0" v-model="answers[28]"/>
          <label class="form-control btn btn-info" for="pole_28_0">Да</label>
          <input name="pole_28" id="pole_28_1" type="radio" value="1" v-model="answers[28]"/>
          <label class="form-control btn btn-info" for="pole_28_1">Нет</label>
          <input name="pole_28" id="pole_28_2" type="radio" value="2" v-model="answers[28]"/>
          <label class="form-control btn btn-info" for="pole_28_2">Частично</label>
        </div>
      </div>
       <button class='btn btn-success' @click="sendData()">Сохранить</button>
    </div>
    <div class="col-md-6">
    <img v-for="img in json" :src="img" :key="img">
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import nprogress from 'nprogress'


export default {
  created:function(){
    this.getfoto();
    this.getanketinfo();
  },
  methods:{
    getanketinfo: function(){
      nprogress.start();
      axios({
        url: "http://eduqa.egechita.ru/back/expertcultureanketinfoanswer/"+this.$route.params.id,
        withCredentials: true,
        method: "get"
      }).then(Response => {
        nprogress.done();
        if(Response.data.isset == 1){
          this.answers = Response.data.info;
        }
      });
    },
    sendData: function(){
      nprogress.start();
      axios({
        data: this.answers,
        url: "http://eduqa.egechita.ru/back/saveexpertcultureanket/"+this.$route.params.id,
        withCredentials: true,
        method: "POST"
      }).then(Response => {
        nprogress.done();
        //this.json = Response.data
      });
    },
    getfoto: function(){
      nprogress.start();
      axios({
        url: "http://eduqa.egechita.ru/back/expertfoto/"+this.$route.params.id,
        withCredentials: true,
      }).then(Response => {
        nprogress.done();
        this.json = Response.data
      });
    }
  },
  data(){
    return {
      json: [],
      answers: []
    }
  }
};
</script>
<style scoped>
input[type="radio"]:checked + label.btn {
  background-color: rgb(24, 218, 201);
}
input[type="radio"] {
  display: none;
}
</style>